import { render, staticRenderFns } from "./SyrupsPowders.vue?vue&type=template&id=6926af38&scoped=true&"
import script from "./SyrupsPowders.vue?vue&type=script&lang=js&"
export * from "./SyrupsPowders.vue?vue&type=script&lang=js&"
import style0 from "./SyrupsPowders.vue?vue&type=style&index=0&id=6926af38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6926af38",
  null
  
)

export default component.exports